<template>
    <div style="width: 100%;">
        <div class="flex-sb">
            <slot name="left">
                <div style="width: 60px;"></div>
            </slot>
            <div class="title very-big-title text-center my-sans-font">{{title}}</div>
            <slot name="right">
                <div style="width: 60px;"></div>
            </slot>
        </div>
            <!-- 分割线 -->
        <div class="star-divider"></div>
    </div>
</template>
<script>
    export default{
        name:'MainTitle',
        props:{
            title:String,
        },
        data(){
            return {

            }
        }
    }
</script>

<style scoped>
        
    .star-divider {
        margin-top: 10px;
        height: 2px;
        background-color: #FFB70A;
    }
    .title {
        color: #0D556D;
        width: 140px;
        text-align: center;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/main_title.vue